import styled from 'styled-components';

import { breakpoints, colors, transition } from 'theme';

export const CmsThreeSectionSliderBlockCarouselNavigationContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: calc(100% + 128px);
  padding: 0 12px;
  max-width: calc(100vw - 16px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: ${colors.waterBlue};
    transition: all ${transition};
    svg {
      * {
        fill: currentColor;
      }
    }
    &[disabled] {
      opacity: 0.33;
    }
    @media (min-width: ${breakpoints[2]}) {
      width: 40px;
      height: 40px;
      padding: 0;
      color: white;
      background: ${colors.waterBlue};
      &[disabled] {
        opacity: 0.33;
        &:hover {
          background: ${colors.waterBlue};
        }
      }
      &:hover,
      &:focus {
        background: ${colors.turtleGreen};
      }
    }
  }
`;

export const CmsThreeSectionSliderBlockCarouselNavigationDots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
